<template>
  <div>
    <Menu>
      <li class="menu-item">
        <a
          v-if="
            $store.state.settings.server &&
              !$store.state.settings.server.publicSignupEnabled
          "
          @click="showAddUser = true"
        >
          <IconText icon="mdi-account">Add user account</IconText>
        </a>
      </li>

      <li class="menu-item">
        <router-link
          v-if="
            ($store.state.auth.user &&
              $store.state.auth.user.roles &&
              $store.state.auth.user.roles.length !== 0) ||
              showSettings
          "
          to="/api-documentation"
        >
          <IconText icon="mdi-information">API documentation</IconText>
        </router-link>
      </li>
      <li class="menu-item">
        <router-link to="/settings">
          <IconText icon="mdi-cog">Global settings</IconText>
        </router-link>
      </li>
      <li class="menu-item">
        <a
          v-if="
            ($store.state.settings.server &&
              $store.state.settings.server.licenseEnabled === undefined) ||
              ($store.state.settings.server &&
                $store.state.settings.server.licenseEnabled)
          "
          @click="showLicense = true"
        >
          <IconText icon="mdi-license">Global license</IconText>
        </a>
      </li>
    </Menu>

    <Domains></Domains>
    <Repos></Repos>

    <License
      v-if="showLicense"
      v-model="showLicense"
      @hide="showLicense = $event"
    ></License>

    <Signup
      v-if="showAddUser"
      v-model="showAddUser"
      @hide="showAddUser = false"
    ></Signup>
  </div>
</template>
<script>
import { postApi } from "@/utils/http";

export default {
  components: {
    Menu: () => import("@/components/main/Menu.vue"),
    Domains: () => import("@/components/main/domain/Section.vue"),
    Repos: () => import("@/components/main/repo/Section.vue"),
    License: () => import("@/components/main/global/License.vue"),
    IconText: () => import("@/components/singles/IconText.vue"),
    Signup: () => import("@/components/main/user/Signup.vue"),
  },
  async created() {
    this.getUserRoles();
  },
  data() {
    return {
      showLicense: false,
      showSettings: false,
      showAddUser: false,
    };
  },
  async mounted() {},
  methods: {
    async getUserRoles() {
      try {
        const res = await postApi("get/userRolesCount");

        this.showSettings = res && res.length !== 0 && res[0] === 0;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
